import { memo } from "react";

function MultiProductChartIcon({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 21L0 17.5V23.5C0.0500819 23.9835 0.156339 24.2064 0.5 24.5L6 27.5V21Z"
        fill="currentColor"
      />
      <path
        d="M7 21L13 17.5V23.5C12.9499 23.9835 12.8437 24.2064 12.5 24.5L7 27.5V21Z"
        fill="currentColor"
      />
      <path
        d="M6.5 20L0.5 16.5L5 14C5 14 5.75437 13.5 6.5 13.5C7.24563 13.5 8 14 8 14L12.5 16.5L6.5 20Z"
        fill="currentColor"
      />
      <path
        d="M21 21L15 17.5V23.5C15.0501 23.9835 15.1563 24.2064 15.5 24.5L21 27.5V21Z"
        fill="currentColor"
      />
      <path
        d="M22 21L28 17.5V23.5C27.9499 23.9835 27.8437 24.2064 27.5 24.5L22 27.5V21Z"
        fill="currentColor"
      />
      <path
        d="M21.5 20L15.5 16.5L20 14C20 14 20.7544 13.5 21.5 13.5C22.2456 13.5 23 14 23 14L27.5 16.5L21.5 20Z"
        fill="currentColor"
      />
      <path
        d="M13.5 8.5L7.5 5V11C7.55008 11.4835 7.65634 11.7064 8 12L13.5 15V8.5Z"
        fill="currentColor"
      />
      <path
        d="M14.5 8.5L20.5 5V11C20.4499 11.4835 20.3437 11.7064 20 12L14.5 15V8.5Z"
        fill="currentColor"
      />
      <path
        d="M14 7.5L8 4L12.5 1.5C12.5 1.5 13.2544 1 14 1C14.7456 1 15.5 1.5 15.5 1.5L20 4L14 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(MultiProductChartIcon);
